import { LAYOUT } from '@/constants/enum'
import { getLocalStorage, setLocalStorage } from '@/helpers/site'

export default {
  namespaced: true,
  state: {
    layout: {
      orientation: LAYOUT.LANDSCAPE,
      template: {
        tabId: '',
        templateId: '',
      },
    },
    modules: {
      background: {},
      avatars: {},
      stamps: {},
      texts: [],
    },
    export: {
      main: '',
      avatarDefault: [],
    },
  },
  getters: {
    getOrientation: state => {
      return state.layout.orientation
    },
    getTemplate: state => {
      return state.layout.template
    },
    getModules: state => {
      return state.modules
    },
    getBackground: state => {
      return state.modules.background
    },
    getAvatars: state => {
      return state.modules.avatars
    },
    getStamps: state => {
      return state.modules.stamps
    },
    getTexts: state => {
      return state.modules.texts
    },
    getExportImage: state => {
      return state.export.main
    },
  },
  mutations: {
    setLayoutValue(state, value) {
      state.layout = value
    },
    setModulesValue(state, value) {
      state.modules = value
    },
    setOrientationValue(state, value) {
      state.layout.orientation = value
    },
    setTemplateValue(state, value) {
      state.layout.template = value
    },
    setBackgroundValue(state, value) {
      state.modules.background = value
    },
    setAvatarsValue(state, value) {
      state.modules.avatars = value
    },
    setStampsValue(state, value) {
      state.modules.stamps = value
    },
    setTextsValue(state, value) {
      state.modules.texts = value
    },
    setExportMain(state, value) {
      state.export.main = value
    },
    setExportValue(state, value) {
      state.export = value
    },
    saveToLocalStorage(state) {
      setLocalStorage(JSON.stringify({ ...state }))
    },
  },
  actions: {
    init({ commit }) {
      if (getLocalStorage() !== null) {
        const dataStorage = JSON.parse(getLocalStorage())
        commit('setLayoutValue', dataStorage.layout)
        commit('setModulesValue', dataStorage.modules)
        commit('setExportValue', dataStorage.export)
      }
    },
    setModules({ commit }, { data, reset = false }) {
      if (reset) {
        commit('setModulesValue', {
          background: {},
          avatars: {},
          stamps: {},
          texts: [],
          ...data,
        })
      } else {
        commit('setModulesValue', data)
      }
    },
    setLayout({ commit }, { data, reset = false }) {
      if (reset) {
        commit('setLayoutValue', {
          ...{
            orientation: LAYOUT.LANDSCAPE,
            template: {
              tab: '',
              template: '',
            },
          },
          ...data,
        })
      } else {
        commit('setLayoutValue', data)
      }
    },
    setExport({ commit }, { data, reset = false }) {
      if (reset) {
        commit('setExportValue', {
          ...{
            main: '',
            avatarDefault: [],
          },
          ...data,
        })
      } else {
        commit('setExportValue', data)
      }
    },
    setOrientation({ commit }, data) {
      commit('setOrientationValue', data)
    },
    setTemplate({ commit }, data) {
      commit('setTemplateValue', data)
    },
    setBackground({ commit }, data) {
      commit('setBackgroundValue', data)
    },
    setAvatars({ commit }, data) {
      commit('setAvatarsValue', data)
    },
    setStamps({ commit }, data) {
      commit('setStampsValue', data)
    },
    setTexts({ commit }, data) {
      commit('setTextsValue', data)
    },
    setExportImage({ commit }, data) {
      commit('setExportMain', data)
    },
    saveToStorage({ commit }) {
      commit('saveToLocalStorage')
    },
  },
}
